import React from 'react';
import { useIsFetching } from 'react-query';
import useHousingStockMatch from '../../../../hooks/useHousingStockMatch';
import ActionWithModalFactory from '../../ActionWithModalFactory/ActionWithModalFactory';
import { links } from '../../../../constants/links';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { modalTypes, buttonTypes } from '../../../../constants/factoryTypes';
import { texts } from '../../../../constants/texts';
import useFlatsGridState from '../../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../../hooks/useHousingStockState';
import useCurrentAddress from '../../../../hooks/useCurrentAddress';

const {
  personalAccounts,
  tenants,
  house: { pages: houseTabs },
} = links;

const Action = () => {
  const match = useHousingStockMatch();

  const { page, pageTab } = match?.params;

  const isHousingStockFetching = useIsFetching(getQueryKeys.companies());

  const showAction =
    pageTab === houseTabs.tenants ||
    pageTab === houseTabs.personalAccounts ||
    page === tenants ||
    page === personalAccounts;

  const { flatsGridQueryKey } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const address = useCurrentAddress();

  return (
    showAction && (
      <ActionWithModalFactory
        actionType={buttonTypes.simple}
        modalType={
          pageTab === houseTabs.tenants || page === tenants
            ? modalTypes.tenant
            : modalTypes.account
        }
        actionText={
          pageTab === houseTabs.tenants || page === tenants
            ? texts.addTenant
            : texts.addPersonalAccount
        }
        actionTextColor="gray"
        actionDisabled={Boolean(isHousingStockFetching)}
        modalProps={{
          address,
          queryKeys: !pageTab
            ? [housingStockQueryKey]
            : [flatsGridQueryKey, housingStockQueryKey],
          withSelectFlat: Boolean(pageTab),
          withSelectHouse: !pageTab,
        }}
      />
    )
  );
};

export default Action;
